import { type RefObject, useEffect, useState } from "react";

// The focus moved, once what's asked for is drawn: on the first of `selectors` inside `root` that can take it, after
// React has drawn the change that asked for it (a form put away, a button no longer disabled while it sends). Not on
// the next frame: a frame can come before React draws, with the form still there or the button still hidden or
// disabled, and the focus then went nowhere (links-on-web.spec.ts failed about one run in ten, on a Mac and on CI).
export function useFocusAfter(root: RefObject<HTMLElement | null>): (...selectors: string[]) => void {
  const [wanted, setWanted] = useState<string[] | null>(null);
  useEffect(() => {
    if (!wanted) return;
    setWanted(null);
    for (const selector of wanted) {
      const el = root.current?.querySelector<HTMLElement>(selector);
      if (el && !el.closest("[hidden]") && !(el instanceof HTMLButtonElement && el.disabled)) {
        el.focus({ preventScroll: true });
        return;
      }
    }
  }, [wanted, root]);
  return (...selectors: string[]) => setWanted(selectors);
}
